if(!customElements.get('vertical-carousel-text')) {

  class ComponentVarticalCarouselText extends HTMLElement {
    constructor() {
      super()

      this.sliderElement = this.querySelector('.keen-slider');
      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
      this.dotSelector = this.querySelector('.keen-dots');
      this.initNavigation = this.querySelector('.keen-init-navigation');
      this.slideLiveRegion = this.querySelector('[data-vertical-slide-live]');

      this.paginateCurrent = this.querySelector('.current');
      this.paginateLength = this.querySelector('.length');
      this.slideAnnounced = false;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initSlider();
      }, 1);

      if (this.initNavigation) {
        this.initNavigation.addEventListener('focus', () => {
          if (this.sliderObj) this.updateSlideAccessibility(this.sliderObj);
        });
      }
    }

    getSlideText(slide) {
      const content = slide?.querySelector('[data-slide-content]');
      return content?.textContent?.replace(/\s+/g, ' ').trim() || '';
    }

    slideHasInteractiveContent(slide) {
      return !!slide?.querySelector('[data-slide-content] a, [data-slide-content] button, [data-slide-content] input, [data-slide-content] select, [data-slide-content] textarea');
    }

    updateSlideAccessibility(keen) {
      const slides = keen.slides();
      const current = keen.currentSlide();
      const currentIndex = slides.indexOf(current);
      const total = slides.length;

      slides.forEach((slide) => {
        const isActive = slide === current;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.setAttribute('tabindex', '-1');

        const slideContent = slide.querySelector('[data-slide-content]');
        if (slideContent) {
          if (isActive && !this.slideHasInteractiveContent(slide)) {
            slideContent.setAttribute('aria-hidden', 'true');
          } else {
            slideContent.removeAttribute('aria-hidden');
          }
        }
      });

      if (this.initNavigation) {
        this.initNavigation.removeAttribute('aria-labelledby');
        this.initNavigation.removeAttribute('aria-describedby');
        this.initNavigation.setAttribute('aria-label', `Go to next slide. Slide ${currentIndex + 1} of ${total}`);
      }
    }

    announceSlide(keen) {
      if (!this.slideLiveRegion) return;
      const slides = keen.slides();
      const currentIndex = slides.indexOf(keen.currentSlide()) + 1;
      const text = this.getSlideText(keen.currentSlide());
      this.slideLiveRegion.textContent = text
        ? `Slide ${currentIndex} of ${slides.length}: ${text}`
        : `Slide ${currentIndex} of ${slides.length}`;
    }

    initSlider() {
      this.sliderObj = new KeenSlider(this.sliderElement, {
        wheel: false,
        vertical: true,
        mode: this.carouselMode,
        loop: this.carouselLoop=="true",
        dots: this.querySelector('.keen-dots'),
        prevButton: this.querySelector('.arrow-prev'),
        nextButton: this.querySelectorAll('.arrow-next, .keen-init-navigation'),
        slideCounter: this.querySelector('.paginate'),
        autoplay: this.carouselAutoplay,
        slideChanged: (keen)=>{
          const slides = keen.slides();
          this.paginateCurrent.textContent = slides.indexOf(keen.currentSlide())+1;
          this.paginateLength.textContent = slides.length;
          this.updateSlideAccessibility(keen);
          if (this.slideAnnounced) {
            this.announceSlide(keen);
          } else {
            this.slideAnnounced = true;
          }
        },
        breakpoints: {
          '(min-width: 1051px)': {
            centered: this.carouselCenteredDesktop=="true",
            spacing: this.carouselSpacingDesktop,
            slidesPerView: this.slidesPerViewDesktop
          },
          '(min-width: 601px) and (max-width: 1050px)': {
            centered: this.carouselCenteredTablet=="true",
            spacing: this.carouselSpacingTablet,
            slidesPerView: this.slidesPerViewTablet
          },
          '(max-width: 600px)': {
            centered: this.carouselCenteredMobile=="true",
            spacing: this.carouselSpacingMobile,
            slidesPerView: this.slidesPerViewMobile
          }
        }
      });

      this.updateSlideAccessibility(this.sliderObj);
    }

  }
  customElements.define('vertical-carousel-text', ComponentVarticalCarouselText);

}
